import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Load } from '../../../../global/interfaces/load';
import { LoadService } from '../../../../global/services/load.service';
import { ToastersService } from '../../../../global/services/toasters.service';
import { SimpleModalComponent } from '../../popups/confirmation-modal/simple-modal.component';
import { RigidAndArticTrailerType } from '../../../../global/types/RigidAndArticTrailerType';
import { trailerFunctions } from '../../../../utils/trailer.functions';

@Component({
  selector: 'app-cargo-tab',
  templateUrl: './cargo-tab.component.html',
  styleUrls: ['../shared-templates.component.less'],
})
export class CargoTabComponent implements OnInit {
  @Output() editLoad: EventEmitter<Load> = new EventEmitter<Load>();
  loads: Load[];
  loadId: string;

  openDots = false;
  isLoading = false;

  constructor(
    private loadService: LoadService,
    private toasterService: ToastersService,
    private modalService: NgbModal,
  ) {}

  async ngOnInit() {
    await this.getLoads();
  }

  async getLoads() {
    this.isLoading = true;
    try {
      this.loads = await this.loadService.getTemplateLoads();
    } catch (error) {
      this.toasterService.createErrorToast(error.message);
    }
    this.isLoading = false;
  }

  onEditLoad(load: Load) {
    this.editLoad.emit(load);
    this.openDots = false;
  }

  async deleteLoad(load: Load) {
    const modal = this.modalService.open(SimpleModalComponent, {
      centered: true,
      backdropClass: 'popup-background',
      windowClass: 'popup-box',
    });
    modal.componentInstance.width = 24;
    modal.componentInstance.hasCancellationButton = true;
    modal.componentInstance.message = `Are you sure you want to delete ${load.name}?`;
    if (!(await modal.result)) return;
    try {
      await this.loadService.deleteLoad([load.id]);
      this.toasterService.createNewToast({ type: 'Success', title: 'Load successfully deleted!' });
      await this.getLoads();
    } catch (error) {
      this.toasterService.createErrorToast(error.message);
    }
  }

  showPopupDots(loadId: string) {
    this.openDots = !this.openDots;
    this.loadId = loadId;
  }

  convertVehicleRequirementsToString(vehicleRequirements: RigidAndArticTrailerType[]): string[] {
    if (!Array.isArray(vehicleRequirements)) {
      vehicleRequirements = [vehicleRequirements];
    }
    return vehicleRequirements.map((vr) => trailerFunctions.trailerTypeToString(vr));
  }
}
